import React from 'react';
import './Stories.css';
// import testimonialImg from '../../../Images/testimonial.jpg'; // Add a testimonial image
import testimonialImg  from "../../../Images/Landing.jpg"

function Stories() {
  return (
    <div className="StoriesCover">
      <div className="innerCover">
        <div className="testimonialImage">
          <img src={testimonialImg} alt="Brenda Ndovi" />
        </div>
        <div className="openLine">
          <p>Saved over 80 hours a year</p>
        </div>
        <div className="StorySection">
          <h3>
            <span className="quoteMark">“</span>
            Payroll used to take at least one full day per month. We’re able to run payroll bi-weekly now, which takes us less than an hour each month.
            <span className="quoteMark">”</span>
          </h3>
        </div>
        <div className="acred">
          <div className="credentials">
            <h3>Brenda Ndovi</h3>
          </div>
          <div className="OrgCredentials">
            <p>Founder & Managing Director</p>
            <p>Favour Foods - Chipata</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stories;






// import "./Stories.css"

// function Stories(){  
//     return <>
//     <div className="StoriesCover">
//         <div className="innderCover">

       
//                  <div className="openLine">

//                         <p>Saved over 80 hours a year</p>

//                  </div>
//                  <div className="StorySection">
//                     <h3>
//                             "Payroll used to take at least one full day per month. We’re able to run payroll bi-weekly now, which takes us less than an hour each month."
//                     </h3>

//                  </div>
//                  <div className="acred">
//                      <div className="credentials">

//                         <h3>Brenda Ndovi</h3>

//                      </div>
//                       <div className="OrgCredentials">

//                             <div className="OrgTitle">
//                                 <p>Founder & Managing Director</p>

//                             </div>
//                             <div className="OrgName">

//                                 <p>Favour Foods - Chipata</p>

//                             </div>

//                      </div>

//                  </div>

//                  </div>


     
//         </div>
        
//     </>

// }

// export default Stories;